import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES, ModalDirective} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {LoginService} from "../service/login.service";
import {User} from "../domain/user";
import {FILE_UPLOAD_DIRECTIVES} from "ng2-file-upload/ng2-file-upload";
import {Bank} from "../domain/bank";
import {BankService} from "../service/bank.service";
import {FILE_MAX_SIZE, IsExpirated, KmFormat, VALID_MIME_TYPES} from "../validators/validators";
import {ProcedureService} from "../service/procedure.service";
import {FileUploaderCustom} from "ng2-file-upload/components/file-upload/FileUploaderCustom";
import {Procedure} from "../domain/procedure";
import {ExpirationType} from "../domain/expirationType";
import {Observable} from "rxjs";
import {NavigationService} from "../service/navigation.service";

@Component({
    selector: 'procedures-panel',
    template: require('./procedures.panel.component.html'),
    styles: [require('./procedures.panel.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe, KmFormat, IsExpirated],
})
export class ProceduresPanelComponent implements OnInit, AfterViewInit {


    private data: Vehicle[];

    private banks: Bank[];

    public bankTodos: Bank;

    private filter: Vehicle;

    public error: any;
    public reportMessage: string;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    private userLogged: User;

    public canEditProcedure: boolean;
    public canViewProcedure: boolean;

    public showFilters: boolean;

    public oneClickBulkLoad: boolean;

    public expirationsType: ExpirationType[];

    @ViewChild('bulkLoadProcedure') bulkLoad: ElementRef;
    @ViewChild('bulkLoadProcedureModal') bulkLoadModal: ModalDirective;
    public errorsBulkLoad: string[];

    public uploaderBulkLoad: FileUploaderCustom;
    public hasBulkLoadDropZoneOver: boolean;

    public withDocuments: boolean;

    public sendMailSuccess: boolean;
    public sendMailError: boolean;

    constructor(private router: Router,
                private procedureService: ProcedureService,
                private bankService: BankService,
                private loginService: LoginService,
                private navigationService: NavigationService) {
        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los bancos.');
            });

        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
        /*this.form.valueChanges
         .debounceTime(400)
         .subscribe(this.find.bind(this));*/
    }

    private init(): void {

        this.procedureService.getExpirationTypes().subscribe(
            (data) => {
                this.expirationsType = data;
            }
            ,
            () => {
                this.bindError('Ocurrió un error al buscar los tipos de expiración.');
            });

        this.data = [];

        this.banks = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.bankTodos = new Bank();
        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';

        this.canEditProcedure = false;
        this.canViewProcedure = false;

        this.showFilters = false;

        this.errorsBulkLoad = [];

        this.createUploaderBulkLoad();

        this.filter = new Vehicle();
        this.form = new FormGroup({
            patent: new FormControl(),
            bank: new FormControl(),
            contractNumber: new FormControl(),
            cuit: new FormControl(),
            itemsPerPage: new FormControl(),

            withDocuments: new FormControl()
        });

        if (!this.filter.contract.bank.id) {
            this.filter.contract.bank = this.bankTodos;
        }

        this.oneClickBulkLoad = false;

        this.withDocuments = false;

        this.sendMailSuccess = false;
        this.sendMailError = false;
    }

    public find(): void {
        this.getData(1);
    }

    public filterEmpty(): boolean {
        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit
            || (this.filter.contract.bank && this.filter.contract.bank.id != ''));
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.filter.contract.bank = banks[0];
        }
    }

    private getData(page: number): void {
        this.error = null;
        this.reportMessage = null;

        if (!this.filterEmpty()) {
            this.loading = true;

            this.procedureService.findProcedure(this.filter, page, this.itemsPerPage).subscribe(
                (data) => {
                    this.refreshData(data);
                    this.page = page;
                },
                () => {
                    this.bindError('Ocurrió un error al buscar los vehículos.');
                });
        }
    }

    private refreshData(page: Page): void {
        this.data = page.content;
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public editItem(item: Vehicle): void {
        this.router.navigate(['app/home/editProcedure', item.id]);
    }

    public editProcedure(event: any, item: Procedure): void {
        event.preventDefault();
        this.navigationService.setBackParameters({tabSelected: 'procedures'});
        this.router.navigate(['app/home/editSingleProcedure', item.id]);
    }

    public downloadFilterProcedures(): void {
        this.error = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            this.reportMessage = 'Creando reporte...';

            /*
             * Se exportan todos las patentes de vehículos que cumplan con el filtro.
             * Sólo las patentes de vehículos de la página actual se descargan.
             */

            window.location.href = window.location.origin +
                ProcedureService.getURLFilterProcedures(this.filter, this.page, this.itemsPerPage, this.withDocuments);

            this.loading = false;
        }
    }

    public close(saved: Vehicle): void {
        if (saved) {
            this.find();
        }
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        this.canEditProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
        this.canViewProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'VIEW', 'PROCEDURES');

        if (this.userLogged.rol.client) {
            if (this.userLogged.cuit) {
                this.filter.contract.cuit = this.userLogged.username;
            } else {
                this.filter.patent = this.userLogged.username;
            }
            this.filter.contract.bank.id = this.userLogged.bank.id;
            this.showFilters = false;
        } else {
            this.showFilters = true;
        }
        this.getPage(1);
    }

    public createUploaderBulkLoad(): void {
        this.uploaderBulkLoad = new FileUploaderCustom({
            url: 'procedure/bulkLoad',
            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             'image/jpeg', 'image/gif', 'image/png']*/
            allowedMimeType: VALID_MIME_TYPES,
            maxFileSize: FILE_MAX_SIZE
        });
        this.hasBulkLoadDropZoneOver = false;

        this.uploaderBulkLoad.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de trámites de vehículos no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        ProcedureService.getURLProcedureBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de trámites de vehículos cancelada.");
                }
            }
            this.oneClickBulkLoad = false;
            this.showBulkLoadModal();
        };

        this.uploaderBulkLoad.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 200) {//OK
                let message = response.split("|");
                this.errorsBulkLoad = [];
                this.errorsBulkLoad[0] = message[0];

                if (message.length > 1) {
                    window.location.href = window.location.origin +
                        ProcedureService.getURLProcedureBulkload(message[1]);
                }
            }
            this.loading = false;
            this.oneClickBulkLoad = false;
            this.showBulkLoadModal();
        };
    }

    public fileOverBulkLoad(e: any): void {
        this.hasBulkLoadDropZoneOver = e;
    }

    public ngAfterViewInit() {
        /*Limpieza de inputs al agregar a la cola el archivo*/
        this.uploaderBulkLoad.onAfterAddingFile = (
            item => {
                this.bulkLoad.nativeElement.value = '';
                this.reportMessage = null;
            });
    }

    public showBulkLoadModal(): void {
        this.bulkLoadModal.show();
        this.disableLoading();
    }

    public hideBulkLoadModal(): void {
        this.bulkLoadModal.hide();
        this.errorsBulkLoad = [];
    }

    public disableLoading(): void {
        this.loading = false;
        this.oneClickBulkLoad = false;
    }

    public enableLoading(): void {
        this.loading = true;
    }

    public enableOneClickBulkload(): void {
        this.oneClickBulkLoad = true;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }

    public enableMultipleFiles(): boolean {
        return false;
    }


    public createProcedure(): void {
        this.router.navigate(['app/home/createProcedure']);
    }

    public getState(procedure: Procedure): string {
        return this.transform(procedure.done, procedure.customDate);
    }
    // No uso el validator porque cambian algunas cosas en este caso...TODO: Mover a una clase aparte (o agregar a validator), tambien se usa en procedures.editor
    private transform(done: boolean, date: string): string {

        if (done) {
            return 'RESUELTO';
        }

        /*
        if (unique) {
            return 'A VENCER'; // Si es unico, y no esta resuelto, no vence nunca
        }
        */

        let todayDate = new Date(Date.parse(Date()));
        let expiratedDateStr: string[];
        let expiratedDate: Date;

        if (date !== undefined && date !== null) {
            if (date.includes('/')) {
                expiratedDateStr = date.split('/');
                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
            } else if (date.includes('-')) {
                expiratedDateStr = date.split('-');
                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
            }
        }

        return expiratedDate > todayDate ? 'A VENCER' : 'VENCIDO';
    }

    public sendMail(item: Procedure, event: any): void {
        event.preventDefault();
        this.sendMailSuccess = false;
        this.sendMailError = false;
        item.withSendMail = true;
        this.procedureService.sendMail(item).subscribe(
            () => {
                item.withSendMail = false;
                item.sent = true;
                this.sendMailSuccess = true;
            },
            (error) => {
                if (error.status == 501) {//NOT_IMPLEMENTED
                    this.bindError('Ocurrió un error al enviar mail.')
                }

                item.withSendMail = false;
                this.sendMailError = true;
            });
    }


}




/** WEBPACK FOOTER **
 ** ./src/app/procedures/procedures.panel.component.ts
 **/